import { HttpErrorResponse } from "@angular/common/http";
import { createAction, props } from "@ngrx/store";
import { LearnerResourcesDto, UpdateLearnerResourcesDto } from "src/app/_models/LearnerResources";
import { LearnerResourcesActionTypes } from "src/app/constants/StoreConstants";

export const ResetLearnerResources = createAction(
  LearnerResourcesActionTypes.ResetLearnerResourcesState
);

export const GetModuleTypesOfResources = createAction(
  LearnerResourcesActionTypes.GetModuleTypesOfResources,
  props<{courseId: number}>()
);

export const GetModuleTypesOfResourcesSuccess = createAction(
  LearnerResourcesActionTypes.GetModuleTypesOfResourcesSuccess,
  props<{result: string[]}>()
);

export const GetModuleTypesOfResourcesError = createAction(
  LearnerResourcesActionTypes.GetModuleTypesOfResourcesError,
  props<{error: HttpErrorResponse}>()
);

export const GetLearnerResources = createAction(
  LearnerResourcesActionTypes.GetLearnerResources,
  props<{courseId: number; langCode: string; isInitialLoad: boolean}>()
);

export const GetLearnerResourcesSuccess = createAction(
  LearnerResourcesActionTypes.GetLearnerResourcesSuccess,
  props<{result: LearnerResourcesDto[]}>()
);

export const GetLearnerResourcesError = createAction(
  LearnerResourcesActionTypes.GetLearnerResourcesError,
  props<{error: HttpErrorResponse}>()
);

export const UpdateLearnerResources = createAction(
  LearnerResourcesActionTypes.UpdateLearnerResources,
  props<{updateFilter : UpdateLearnerResourcesDto}>()
);

export const UpdateLearnerResourcesSuccess = createAction(
  LearnerResourcesActionTypes.UpdateLearnerResourcesSuccess,
  props<{result: boolean}>()
);

export const UpdateLearnerResourcesError = createAction(
  LearnerResourcesActionTypes.UpdateLearnerResourcesError,
  props<{error: HttpErrorResponse}>()
);